export default {"src":"/_next/static/image/public/images/ic_secure_payment.eb3fd0ae90363e75bc84da7ccbed35cf.svg","height":28,"width":39};